import { configureStore } from '@reduxjs/toolkit';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import shiftPlanReducer from './slices/shiftPlanSlice';
import rosterAndRatesReducer from './slices/rosterAndRatesSlice';
import reviewAndPublishReducer from './slices/reviewAndPublishSlice';
import volumeAndWipReducer from './slices/volumesAndWipSlice';
import errorReducer from './slices/errorSlice';
import getAllShiftPlansReducer from './slices/GetAllShiftPlansSlice';
import navigationReducer from './slices/navigationSlice';
import themeReducer from './slices/themeSlice';
import settingsReducer from './slices/settingsSlice';
import stationAssignmentReducer from './slices/stationAssignmentSlice';
import workItemDetailReducer from '../pages/workItemDetail/slice';
import { RootState } from './types';

// Configure the store
export const store = configureStore({
  reducer: {
    shiftPlan: shiftPlanReducer,
    rosterAndRates: rosterAndRatesReducer,
    reviewAndPublish: reviewAndPublishReducer,
    volumesAndWip: volumeAndWipReducer,
    error: errorReducer,
    getAllShiftPlans: getAllShiftPlansReducer,
    navigation: navigationReducer,
    theme: themeReducer,
    settings: settingsReducer,
    stationAssignment: stationAssignmentReducer,
    workItemDetail: workItemDetailReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [],
      },
    }),
});

// Export store types
export type AppDispatch = typeof store.dispatch;

// Export typed hooks for use throughout the app
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

// Export store as default
export default store;
